<template>
    <div id="main">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">{{ $t('nova-linha-produto') }}</h1>
                </div>
                <div class="header-buttons">
                    <button class="delete-btn" type="button" tag="button" @click="fechar()">
                        {{ $t('fechar') }}
                    </button>
                    <button
                        v-if="permissao.create"
                        class="save-btn"
                        type="button"
                        @click="save"
                        :disabled="isSaving"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>

            <div class="columns is-multiline mt-2">
                <div class="column is-6">
                    <v-input
                        v-model="lp.descricao"
                        :id="'descricao'"
                        :placeholder="'descricao-da-linha-placeholder'"
                        :maxlength="100"
                        :title="'descricao-da-linha-produto'"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="!lp.descricao"
                        ref="descricaoInput"
                    />
                </div>
                <div class="column is-6">
                    <vs-select
                        ref="gpSelect"
                        :title="'grupo-linha-produto'"
                        :options="grupos"
                        v-model="gruposelected"
                        :search="loadAllGroups"
                        :focusin="loadAllGroups"
                        :onChange="updateGrupo"
                        :keydown="tabSelectGrupo"
                        :placeholder="'grupo-do-sub-grupo-placeholder'"
                        :invalid="!lp.grupoproduto"
                    />
                </div>
                <div class="column is-6">
                    <vs-select
                        ref="subgrupoInput"
                        :title="'sub-grupo-linha-produto'"
                        :options="subgrupos"
                        v-model="subgruposelected"
                        :search="loadSubGrupo"
                        :focusin="loadSubGrupo"
                        :onChange="updateSubgrupo"
                        :keydown="tabSelectSubGrupo"
                        :placeholder="'sub-grupo-linha-placeholder'"
                        :invalid="!lp.subgrupoproduto"
                        :disabled="!lp.grupoproduto"
                    />
                </div>
                <div class="column is-6">
                    <label for="situacao" v-text="$t('situacao')" />
                    <v-select
                        ref="situacaoSelect"
                        :selectOnTab="true"
                        :searchable="false"
                        :options="situacoes"
                        :value="situacao"
                        @input="updateSituacao"
                        :getOptionLabel="getLabel"
                        placeholder="situacao-da-marca-placeholder"
                        class="no-clear"
                    >
                        <template slot="no-options">{{ $t('sem-resultados') }}</template>
                    </v-select>
                </div>
            </div>
        </div>
        <br />
    </div>
</template>

<script>
import LinhaProdutoService from '@/services/LinhaProdutoService';
import SubGrupoProdutoService from '@/services/SubGrupoProdutoService';
import GrupoProdutoService from '@/services/GrupoProdutoService';
import LinhaValidation from '@/services/validations/LinhaValidation';
import Message from '@/models/Message';

export default {
    props: {
        gruposelected: {
            default() {
                return {};
            },
            type: Object,
        },
        subgruposelected: {
            default() {
                return {};
            },
            type: Object,
        },
    },
    data() {
        return {
            isSaving: false,
            lp: {
                situacao: 1,
                subgrupoproduto: { idsubgrupoproduto: null },
                grupoproduto: { idgrupoproduto: null },
            },
            editable: false,
            title: '',
            msgs: [],
            grupo: null,
            grupos: [],
            subgrupo: null,
            subgrupos: [],
            validation: null,
            loadGroup: false,
            loadSubGroup: false,
            canSelectSubGrupo: false,
            canSelectGrupo: false,
            situacao: { label: 'ativo', id: 1 },
            situacoes: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            isUpdate: false,
        };
    },
    created() {
        this.grupo = this.gruposelected;
        this.subgrupo = this.subgruposelected;
        this.service = new LinhaProdutoService(this.$http, this.$router);
        this.gruposervice = new GrupoProdutoService(this.$http, this.$router);
        this.subgruposervice = new SubGrupoProdutoService(this.$http, this.$router);
        this.validation = new LinhaValidation(this.msgs);
        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'linhas');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'linhas-produto' },
            });
        } else {
            this.isUpdate = this.$route.params.id ? true : false;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'linha-produto' },
                });
            }
        }
    },
    methods: {
        fechar(action = 'close', situacao = 1, linha) {
            this.$emit('fecharModal', 'linha-produto', action, situacao, linha);
        },
        tabSelectGrupo(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectGrupo = true;
            if (e.code == 'Tab' && this.canSelectGrupo) {
                this.$refs.gpSelect.typeAheadSelect();
                setTimeout(() => {
                    this.$refs.subgrupoInput.focus();
                }, 200);
            }
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.lp.situacao = situacao.id;
                this.situacao = situacao;
            }
        },
        tabSelectSubGrupo(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectSubGrupo = true;
            if (e.code == 'Tab' && this.canSelectSubGrupo) {
                this.$refs.subgrupoInput.typeAheadSelect();
                this.$refs.subgrupoInput.focus();
            }
        },
        getSituacao() {
            return this.situacoes.filter((s) => s.id == this.lp.situacao);
        },
        loadAllGroups() {
            if (this.grupos.length == 0) {
                this.gruposervice
                    .findAllCombo('')
                    .then(this.mapItems)
                    .then((allgroups) => {
                        this.grupos = allgroups;
                        this.grupos.sort();
                    });
            }
        },
        // loadGrupo(search, loading) {
        //   if(loading) {
        //     loading(true);
        //   }
        //   this.gruposervice
        //     .findAllCombo(search?search:"")
        //     .then(this.mapItems)
        //     .then(allgroups => {
        //       this.grupos = allgroups;
        //       this.grupos.sort();
        //       if(loading) {
        //         loading(false);
        //       }
        //     }, 350);
        // },
        loadSubGrupo() {
            this.subgruposervice
                .findByGroup(0, 10, this.gruposelected.id)
                .then(this.mapItems)
                .then((allsubgroups) => {
                    this.subgrupos = allsubgroups;
                    this.subgrupos.sort();
                    if (this.subgrupo && this.subgrupo.id) {
                        this.updateSubgrupo(
                            this.subgrupos.filter(
                                (sg) =>
                                    sg.id.idsubgrupoproduto == this.subgrupo.id.idsubgrupoproduto
                            )[0]
                        );
                    }
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally((_) => {
                    this.subgrupo = null;
                    this.lp.subgrupoproduto = null;
                });
        },
        mapItems(body) {
            let grupolist = body.content.map((r) => {
                return {
                    id: r,
                    label: r.descricao,
                };
            });
            return grupolist;
        },
        updateGrupo(gp) {
            if (gp) {
                this.lp.grupoproduto = gp.id;
                this.gruposelected = gp.id;
                this.gruposelected.label = gp.label;
                this.subgruposelected = {};
                this.subgrupo = {};
                if (this.lp.grupoproduto) {
                    this.loadSubGrupo();
                }
            } else {
                this.lp.grupoproduto = null;
                this.grupo = null;
                this.updateSubgrupo(null);
            }
        },
        updateSubgrupo(sgp) {
            if (sgp) {
                this.lp.subgrupoproduto = sgp.id;
                this.subgruposelected = sgp.id;
                this.subgruposelected.label = sgp.label;
                this.subgrupo = sgp.id;
                this.subgrupo.label = sgp.label;
            } else {
                this.lp.subgrupoproduto = null;
                this.subgrupo = null;
            }
        },
        save() {
            this.lp.grupoproduto.idgrupoproduto = this.gruposelected.id;
            this.lp.grupoproduto.label = this.gruposelected.label;
            this.lp.subgrupoproduto.idsubgrupoproduto = this.subgruposelected.id;
            this.lp.subgrupoproduto.label = this.subgruposelected.label;
            this.lp = this.mapTosave(this.lp);

            if (this.validation.validate(this.lp, this.$refs)) {
                this.isSaving = true;
                this.service
                    .save(this.lp)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-linha-salva';
                            if (this.lp.id) {
                                msg = 'msg-linha-editada';
                            }
                            this.lp.id = body.content.id;

                            this.msgs.push(new Message('success', msg, true));
                            redirect(2);
                        } else {
                            if (this.$t(body.message)) {
                                this.msgs.push(new Message('alert', body.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                        this.isSaving = false;
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                    })
                    .finally((_) => {
                        this.isSaving = false;
                        this.fechar('save', this.lp.situacao, this.lp);
                    });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    margin-bottom: 40px;
    min-height: 500px;
    padding: 17px 15px;
    border-radius: 5px;
}
@media only screen and (max-width: 600px) {
    .page {
        min-height: 700px;
    }
}
</style>
